<template>
  <div class="spinner"></div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
}
</script>

<style lang="scss" scoped>
.spinner {
  width: 16px;
  height: 16px;
  margin: -8px 0 0 -8px;
  border: 2px solid varFigma(neutral-80-lighter);
  border-radius: 50%;
  border-top: 2px solid varFigma(brand-60-base);
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
